import React from "react";
import ReactDOM from "react-dom";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { msalInstance } from "./infrastructure/auth/authConfig";
import GlobalStyles from "jb_component_library/components/GlobalStyles/GlobalStyles";
import ThemeProvider from "./theme/ThemeProvider";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
	<MsalProvider instance={msalInstance}>
		<BrowserRouter>
			<ThemeProvider theme={"group"}>
				<GlobalStyles />
				<App />
			</ThemeProvider>
		</BrowserRouter>
	</MsalProvider>,
	document.getElementById("root")
);
